module.exports = __webpack_public_path__ + "static/howtosearch-3d1ef476c0ab0f1ef80e0a0eb30a0127.gif";